/** 日本語。未訳のキーは英語にフォールバックします。 */
const ja = {
  Nav: {
    Home: 'ホーム',
    Dashboard: 'ダッシュボード',
    Account: 'アカウント',
    Cards: 'カード',
    Keychip: 'キーチップ',
    Import: 'インポート',
    Announcements: 'お知らせ',
    Contributors: 'クレジット',
    SignIn: 'ログイン',
    SignUp: '新規登録',
    SignOut: 'ログアウト',
    Games: 'ゲーム',
    Theme: 'テーマ',
    Language: '言語',
  },
  Common: {
    Profile: 'プロフィール',
    Rating: 'レーティング',
    PlayRecord: 'プレイ記録',
    MusicList: '楽曲一覧',
    Rival: 'ライバル',
    UserRanking: 'プレイヤーランキング',
    Setting: '設定',
    Loading: '読み込み中…',
    Empty: 'まだ何もありません。',
    Error: 'エラーが発生しました。',
    Retry: '再試行',
    Save: '保存',
    Cancel: 'キャンセル',
    Remove: '削除',
    Add: '追加',
    Close: '閉じる',
    Colon: '：',
    Level: 'レベル',
    Score: 'スコア',
    PlayCount: 'プレイ回数',
    LastPlay: '最終プレイ',
    Page: '{{total}} ページ中 {{page}} ページ',
    Previous: '前へ',
    Next: '次へ',
    NoGameData: 'このゲームのセーブデータがまだありません。1 クレジット遊ぶと表示されます。',
    NoCard: '先にカードを連携してください。カードは筐体が作るもので、ポータルからは作れません。',
    Export: 'エクスポート',
    Name: '名前',
    Rank: '順位',
    Player: 'プレイヤー',
    Id: 'ID',
    Total: '合計',
    Never: 'なし',
  },
  Auth: {
    Username: 'ユーザー名',
    Password: 'パスワード',
    Email: 'メールアドレス',
    DisplayName: '表示名',
    UsernameOrEmail: 'ユーザー名またはメールアドレス',
    SignInTitle: 'ログイン',
    SignUpTitle: 'アカウント作成',
    SignInAction: 'ログイン',
    SignUpAction: 'アカウントを作成',
    NoAccount: 'アカウントをお持ちでないですか？',
    HaveAccount: 'すでにアカウントをお持ちですか？',
    ForgotPassword: 'パスワードをお忘れですか？',
    ResetTitle: 'パスワードの再設定',
    ResetAction: 'パスワードを再設定',
    SendCode: 'コードを送信',
    Code: '確認コード',
    NewPassword: '新しいパスワード',
    TotpTitle: '二段階認証',
    TotpPrompt: '認証アプリに表示された 6 桁のコードを入力してください。',
    TotpAction: '確認',
    SignedOut: 'ログアウトしました。',
  },
  Home: {
    Tagline: 'CHUNITHM・maimai DX・O.N.G.E.K.I. のためのネットワークです。',
    GetStarted: 'はじめる',
    OpenDashboard: 'ダッシュボードを開く',
  },
  Dashboard: {
    Title: 'ダッシュボード',
    Games: 'あなたのゲーム',
    NoGames: 'セーブデータがありません。',
    ServerRank: 'サーバー内順位',
    TotalPlayers: '全 {{total}} 人中',
    Unranked: 'ランク外',
  },
  Account: {
    Title: 'アカウント',
    Roles: '権限',
    Joined: '登録日',
    ChangePassword: 'パスワードを変更',
    CurrentPassword: '現在のパスワード',
    Updated: '保存しました。',
    MustChange: '新しいパスワードを設定するまで、他の機能は利用できません。',
    ConfirmPassword: '新しいパスワード（確認）',
    PasswordMismatch: 'パスワードが一致しません。',
    PasswordRule: '8 文字以上。',
  },
  Admin: {
    Title: '管理',
    Forbidden: 'このページを表示する権限がありません。',
    Players: 'プレイヤー',
    Search: '検索',
    Status: '状態',
    Active: '通常',
    Banned: '停止中',
    Ban: '停止',
    Unban: '解除',
    BanReasonPrompt: '停止の理由（プレイヤーに表示されます）：',
    Mail: 'メール',
    MailHint:
      '確認コードとパスワード再設定コードの送信に使います。未設定の場合はサーバーログに記録されます。',
    MailEnabled: 'メールを送信する',
    MailHost: 'SMTP ホスト',
    MailPort: 'ポート',
    MailSecure: '暗黙的 TLS（465 番）',
    MailUser: 'ユーザー名',
    MailPassword: 'パスワード',
    MailPasswordKept: '空欄なら変更しません',
    MailFrom: '差出人',
    MailTestTo: 'テスト送信先',
    MailTest: 'テスト送信',
    MailTestSent: 'テストメールを送信しました。',
  },
  Cards: {
    Title: 'カード',
    AccessCode: 'アクセスコード',
    Registered: '登録日',
    LastUsed: '最終利用',
    Default: '既定',
    MakeDefault: '既定にする',
    Bind: 'カードを連携',
    BindHint: '筐体がカードを読み取ったときに表示される 20 桁のアクセスコードを入力してください。',
    Unbind: '連携を解除',
    UnbindConfirm: 'このカードの連携を解除しますか？セーブデータはサーバーに残ります。',
    Empty: '連携されたカードがありません。',
  },
  Keychip: {
    Title: 'キーチップ',
    Serial: 'シリアル',
    Memo: 'メモ',
    Allowed: '許可済み',
    Empty: '登録されたキーチップがありません。',
    Generate: 'キーチップを生成',
    Trusted: '信頼済みキーチップ',
  },
  Import: {
    Title: 'インポート',
    Intro: '他のサーバーからセーブデータを取り込みます。',
    Unavailable: 'このサーバーではまだインポートを利用できません。',
  },
  Announcements: { Title: 'お知らせ', Empty: 'お知らせはありません。', Posted: '投稿日' },
  Contributors: {
    Title: 'クレジット',
    Intro: 'QuiltNET は以下のプロジェクトの成果の上に成り立っています。',
  },
  Eula: {
    Title: '利用規約',
    Accept: '同意する',
    Required: '続行するには利用規約に同意してください。',
  },
  Banned: {
    Title: 'アカウント停止',
    Intro: 'このアカウントはサービスを利用できません。',
    Appeal: '心当たりがない場合は運営者にお問い合わせください。',
  },
  Error: {
    PageTitle: 'このページで問題が発生しました',
    PageHint: '他のページは利用できます。再試行するか、別のページをお選びください。',
    Retry: '再試行',
  },
  NotFound: {
    Title: 'ページが見つかりません',
    Intro: 'そのページは存在しません。',
    Home: 'ホームへ',
  },
  Chuni: {
    Title: 'CHUNITHM',
    Character: 'キャラクター',
    UserBox: 'ユーザーボックス',
    Nameplate: 'ネームプレート',
    Trophy: '称号',
    MapIcon: 'マップアイコン',
    SystemVoice: 'システムボイス',
    Stage: 'ステージ',
    Avatar: 'アバター',
    OverPower: 'オーバーパワー',
    Friend: 'ライバル',
  },
  Mai2: {
    Title: 'maimai DX',
    Photos: 'フォト',
    DxPass: 'DX パス',
    Circle: 'CiRCLE',
    Festa: 'フェスタ',
    ServerMissions: 'サーバーミッション',
    PointExchanges: 'ポイント交換',
    Deluxe: 'DX',
    Standard: 'STD',
  },
  Ongeki: {
    Title: 'O.N.G.E.K.I.',
    Battle: 'バトル',
    Card: 'カード',
    CardGallery: 'カード図鑑',
    MusicRanking: '楽曲ランキング',
    BattlePoint: 'バトルポイント',
    TechScore: 'テクニカル',
    BattleScore: 'バトル',
  },
} as const;

export default ja;
